import type { PropsOf } from '@emotion/react'
import type { FC } from 'react'

import BuildWithAiButton from '@app/pages/playbooks/components/buildWithAiButton'

export type Props = Pick<
  PropsOf<typeof BuildWithAiButton>,
  'playbook' | 'businessContextId' | 'additionalInstructions' | 'onLoadingChange'
> & {
  strategyId?: string
  parentStrategyId?: string
}

const AiPlaybooksModalAction: FC<Props> = ({ playbook, ...rest }) => (
  <BuildWithAiButton
    ctaText={playbook ? `Proceed with ${playbook?.name}` : 'Select a map type'}
    playbook={playbook}
    disabled={!playbook}
    {...rest}
  />
)

export default AiPlaybooksModalAction
